export default {
  id: '0dc0381459',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page" data-name="home">\n    <!-- Top Navbar -->\n    <div class="navbar">\n      <div class="navbar-inner">\n        <div class="title sliding">JS-son Arena</div>\n        <div class="title-large">\n          <div class="title-large-text">JS-son Arena</div>\n        </div>\n      </div>\n    </div>\n    <!-- Toolbar-->\n    <div class="toolbar toolbar-bottom">\n      <div class="toolbar-inner">\n        <a href="https://people.cs.umu.se/tkampik/" class="link external" target="_blank">Timotheus Kampik</a>\n        <a href="https://www.umu.se/" class="link external" target="_blank">Umeå University</a>\n      </div>\n    </div>\n    <!-- Scrollable page content-->\n    <div class="page-content">\n      <div class="block">\n          <div class="intro-div">\n            <div class="intro-text">\n                This page shows how <strong><a href="https://github.com/TimKam/JS-son" class="link external" target="_blank">JS-son</a></strong> agents that learn with rewards based on fair equilibria act in a grid world arena.\n            </div>\n          </div>\n          <div id="arena-grid"></div>\n          <div id="analysis"></div>\n          <div id="reward-plot"></div>\n          <div class="controls">\n              <a class="button button-fill restart-button">Restart</a>\n          </div>\n      </div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};